const roles = [
  {
    id: 'community-lead',
    title: 'Community Lead',
    badge: 'Leadership',
    description:
      'Lead the overall direction of the AWS Student Builder Community MKU, coordinate between teams, and represent the club at university and AWS events.',
    requirements: [
      'Previous leadership or community organising experience',
      'Strong communication and interpersonal skills',
      'Passion for building an inclusive student community',
      'Ability to commit time consistently throughout the semester',
    ],
  },
  {
    id: 'technical-lead',
    title: 'Technical Lead',
    badge: 'Technical',
    description:
      'Guide members through hands-on AWS projects, run technical workshops, support members working toward AWS certifications, and help review project work.',
    requirements: [
      'Practical experience with AWS services or cloud computing',
      'Comfortable explaining technical concepts to beginners',
      'Experience building or contributing to software projects',
      'Working toward or holding an AWS certification is a plus',
    ],
  },
  {
    id: 'events-lead',
    title: 'Events Lead',
    badge: 'Events',
    description:
      'Plan and coordinate community events including workshops, hackathons, study sessions, and networking meetups. Manage logistics and ensure events run smoothly.',
    requirements: [
      'Experience organising events or activities on campus',
      'Strong planning and time management skills',
      'Ability to coordinate with venues, speakers, and sponsors',
      'Comfortable using tools like Meetup, Google Forms, or similar',
    ],
  },
  {
    id: 'marketing-lead',
    title: 'Marketing & Communications Lead',
    badge: 'Communications',
    description:
      'Manage the community\'s social media presence, create content that promotes events and member achievements, and help grow awareness of the club on campus.',
    requirements: [
      'Experience with social media management or content creation',
      'Good written communication skills',
      'Basic graphic design skills (Canva or similar) is a plus',
      'Enthusiasm for storytelling and community promotion',
    ],
  },
];

export default roles;
